// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CashRegisterInvoiceHolderFragment = { __typename?: 'CashRegisterInvoiceHolderDTO', fiscalCode: string | null, lines: Array<string>, lotteryCode: string | null };

export const CashRegisterInvoiceHolderFragment = gql`
    fragment CashRegisterInvoiceHolder on CashRegisterInvoiceHolderDTO {
  fiscalCode
  lines
  lotteryCode
}
    `;
/* eslint-enable */